var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramsSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 114,
    viewBox: "0 0 1920 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 60L24.7 65.5C49.3 71 98.7 82 147.8 83.8C197 85.7 246 78.3 295.2 71.3C344.3 64.3 393.7 57.7 443 61.3C492.3 65 541.7 79 590.8 83.3C640 87.7 689 82.3 738.2 80.2C787.3 78 836.7 79 886 83C935.3 87 984.7 94 1034 101.8C1083.3 109.7 1132.7 118.3 1181.8 110.3C1231 102.3 1280 77.7 1329.2 71C1378.3 64.3 1427.7 75.7 1477 76.8C1526.3 78 1575.7 69 1624.8 70C1674 71 1723 82 1772.2 84.5C1821.3 87 1870.7 81 1895.3 78L1920 75V0H1895.3C1870.7 0 1821.3 0 1772.2 0C1723 0 1674 0 1624.8 0C1575.7 0 1526.3 0 1477 0C1427.7 0 1378.3 0 1329.2 0C1280 0 1231 0 1181.8 0C1132.7 0 1083.3 0 1034 0C984.7 0 935.3 0 886 0C836.7 0 787.3 0 738.2 0C689 0 640 0 590.8 0C541.7 0 492.3 0 443 0C393.7 0 344.3 0 295.2 0C246 0 197 0 147.8 0C98.7 0 49.3 0 24.7 0H0V60Z",
    fill: "#40B1E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramsSvg);
export default __webpack_public_path__ + "static/media/programs_svg.4741a8b55f674360c7a1a93f517f76e5.svg";
export { ForwardRef as ReactComponent };